// UTM Tracking — detect UTM params in URL, store in cookie (first-touch, 30-day expiry)

(function () {
  var UTM_KEYS = ['utm_source', 'utm_campaign', 'utm_term'];
  // Google Ads puts the matched keyword in utm_term by convention, but some ad
  // builders write utm_keyword instead. Accept either and store it as utm_term
  // so everything downstream keeps reading one field.
  var UTM_ALIASES = { utm_term: ['utm_term', 'utm_keyword'] };
  var COOKIE_NAME = 'utm_data';
  var COOKIE_EXPIRY_DAYS = 30;

  function setCookie(name, value, days) {
    var expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires.toUTCString() + '; path=/; SameSite=Lax; Secure';
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^|; )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  }

  // Parse UTM params from current URL
  var searchParams = new URLSearchParams(window.location.search);
  var utmParams = {};
  var hasUtm = false;

  UTM_KEYS.forEach(function (key) {
    var names = UTM_ALIASES[key] || [key];
    var value = '';
    for (var i = 0; i < names.length && !value; i++) {
      value = searchParams.get(names[i]) || '';
    }
    if (value) {
      utmParams[key] = value;
      hasUtm = true;
    }
  });

  // First-touch: only set cookie if UTM params exist in URL and no cookie yet
  if (hasUtm && !getCookie(COOKIE_NAME)) {
    utmParams.timestamp = Date.now();
    setCookie(COOKIE_NAME, JSON.stringify(utmParams), COOKIE_EXPIRY_DAYS);
  }

  // Expose getter for form submission
  window.getUtmData = function () {
    var raw = getCookie(COOKIE_NAME);
    if (!raw) return {};
    try { return JSON.parse(raw); } catch (e) { return {}; }
  };

  // ============================================================
  // Lead source — the single tag the quote form reports back, so
  // paid leads can be counted against ad spend.
  //
  // GOOGLE  — the visit carried a Google Ads click id (gclid/gbraid/
  //           wbraid) or a google/adwords utm_source
  // <OTHER> — any other utm_source, uppercased (e.g. FACEBOOK, YELP)
  // DIRECT  — no attribution data at all
  //
  // Attribution rule: a paid click always wins and overwrites whatever
  // was stored, so someone who browsed organically last week and then
  // clicks an ad today is still counted as GOOGLE. Everything else keeps
  // the existing first-touch behaviour.
  // ============================================================
  var SOURCE_COOKIE = 'lead_source';
  var GOOGLE_CLICK_IDS = ['gclid', 'gbraid', 'wbraid'];
  var GOOGLE_UTM_SOURCES = ['google', 'adwords', 'google-ads', 'googleads'];

  function readStoredSource() {
    var raw = getCookie(SOURCE_COOKIE);
    if (!raw) return null;
    try { return JSON.parse(raw); } catch (e) { return null; }
  }

  // A Google Ads click id on the current URL is the strongest signal we get
  var clickId = '';
  GOOGLE_CLICK_IDS.forEach(function (key) {
    if (!clickId) clickId = searchParams.get(key) || '';
  });

  var currentUtmSource = (searchParams.get('utm_source') || '').toLowerCase();
  var isGoogleAdsVisit = !!clickId || GOOGLE_UTM_SOURCES.indexOf(currentUtmSource) !== -1;

  var stored = readStoredSource();
  var leadSource;

  if (isGoogleAdsVisit) {
    leadSource = { source: 'GOOGLE', gclid: clickId, timestamp: Date.now() };
    setCookie(SOURCE_COOKIE, JSON.stringify(leadSource), COOKIE_EXPIRY_DAYS);
  } else if (stored && stored.source) {
    leadSource = stored;
  } else {
    var storedUtm = window.getUtmData();
    var fallbackSource = currentUtmSource || (storedUtm.utm_source || '').toLowerCase();

    leadSource = {
      source: fallbackSource ? fallbackSource.toUpperCase() : 'DIRECT',
      gclid: '',
      timestamp: Date.now()
    };

    // Only persist a real source — don't lock a visitor into DIRECT
    if (fallbackSource) {
      setCookie(SOURCE_COOKIE, JSON.stringify(leadSource), COOKIE_EXPIRY_DAYS);
    }
  }

  // Expose getter for form submission
  window.getLeadSource = function () {
    return {
      source: leadSource.source || 'DIRECT',
      gclid: leadSource.gclid || ''
    };
  };
})();
